<template>
    <div>
        <div v-if="loading" class="loading-container">
            <atom-spinner
                :animation-duration="1000"
                :size="60"
                color="#ff1d5e"
            />
        </div>

        <div class="animated fadeIn">
            <loader v-if="loading"></loader>

            <div v-if="!loading">
                <component-header
                    title="Templates"
                    :isLoading="isloading"
                    @reload-data="reloadData"
                    @create-press="$router.push({ path: 'notification-template/create' })"
                    createButtonText="Create Template"
                    :hasback="false"
                    :hasOption="true"
                    :isCreate="false"
                    @search-query="val => (filter = val)"
                />

                <b-card class="card-wrap" border-variant="info">
                    <div>
                        <div class="table-wrapper">
                            <b-table
                                class="template-table mt-3 tableRadius"
                                :items="filteredTemplates"
                                :fields="templateColumns"
                                :current-page="currentPage"
                                :per-page="perPage"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                hover
                                bordered
                                responsive
                                show-empty
                                thead-class="header"
                            >

                            <template #cell(SlNo)="data">
                                {{ data.index + 1 }}
                            </template>

                            <template #cell(body)="data">
                                {{ showBody(data.item) }}
                            </template>

                            <template #cell(action)="data">
                                <ActionButtonGroup
                                    v-if="data.item"
                                    :showDelete="true"
                                    @delete="deleteRule(data.item)"
                                />
                            </template>

                            <template #empty>
                                <div class="text-center">
                                    {{ isloading ? "Loading..." : "No data available." }}
                                </div>
                            </template>

                            </b-table>
                        </div>
                    </div>

                    <div class="pagination-wrapper">
                        <b-pagination
                            v-model="currentPage"
                            :per-page="perPage"
                            :total-rows="filteredTemplates.length"
                            prev-text="Prev"
                            next-text="Next"
                            hide-goto-end-buttons
                        />
                    </div>
                </b-card>
            </div>
        </div>
    </div>
</template>


<script>
import { mapGetters } from "vuex";
import ComponentHeader from "@/components/componentNewHeader";
import ActionButtonGroup from "@/components/Common/ActionButtonGroup.vue";
import loader from "@/components/loader/nipigeloader.vue";
import { AtomSpinner } from "epic-spinners";

export default {
    name: "NotificationTemplateList",

    data() {
        return {
            filter: "",
            loading: false,
            isloading: false,
            currentPage: 1,
            perPage: 8,
            sortBy: "createdAt",
            sortDesc: true,

            templateColumns: [
                { key: "SlNo", label: "Sl No" },
                { key: "service", label: "Type" },
                { key: "concern" },
                { key: "body" },
                { key: "action", thStyle: { width: "8%" } },
            ],
        };
    },

    components: {
        ComponentHeader,
        ActionButtonGroup,
        AtomSpinner,
        loader,
    },

    computed: {
        ...mapGetters({
            getFetchTemplateList: "emailTemplate/GetFetchTemplateList",
        }),

        filteredTemplates() {
            if (!Array.isArray(this.getFetchTemplateList)) return [];

            return this.getFetchTemplateList.filter(el => {
                const text = (el.service + el.concern + el.body)?.toLowerCase() || "";
                return text.includes(this.filter.toLowerCase());
            });
        },
    },

    methods: {
        editRule(data) {
            this.$router.push({
                name: "templateSetupEdit",
                params: { id: data._id },
            });
        },

        showBody(data) {
            if (data.service === "WHATSAPP") {
                let bodyComponent = data.components?.find(
                    c => c.type === "body"
                );
                let textBody = bodyComponent?.parameters?.map(p => p.text);
                return textBody?.join(", ") || "";
            }
            return data.body;
        },

        async reloadData() {
            this.isloading = true;
            await this.$store.dispatch("emailTemplate/fetchTemplateAction");
            this.templateList = this.getFetchTemplateList;
            this.isloading = false;
        },

        async deleteRule(data) {
            this.$swal({
                title: "Delete this Template?",
                text: "Are you sure? This will be removed.",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, Delete it!",
                cancelButtonColor: "#d33",
                reverseButtons: true,
            }).then(async result => {
                if (result.value) {
                    this.isloading = true;

                    await this.$store.dispatch("emailTemplate/deleteTemplate", data._id);

                    this.$swal({
                        type: "success",
                        title: "Deleted",
                        text: "Template deleted successfully!",
                    });

                    await this.reloadData();
                    this.isloading = false;
                }
            });
        },
    },

    async mounted() {
        this.loading = true;
        await this.$store.dispatch("emailTemplate/fetchTemplateAction");
        this.loading = false;
    },

    async activated() {
        await this.reloadData();
    },
};
</script>


<style scoped>
.loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
}

.table-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.template-table {
    border-radius: 12px;
}

.action-buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

.circle-btn {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.text-center {
    text-align: center;
}




.pagination-wrapper {
    float: right;
    margin-top: 1rem;
}

@media (max-width: 767.98px) {
    .pagination-wrapper {
        float: none;
        display: flex;
        justify-content: center;
        margin-top: 1rem;
    }

    .table-wrapper {
        margin: 0 -15px;
    }
}
</style>
